import Rebase from 're-base';

const config = {
  apiKey: "AIzaSyDsK1sUoPCEDUOBpNp3Q5B3n5z8ZykH1P8",
  authDomain: "build-the-mountain.firebaseapp.com",
  databaseURL: "https://build-the-mountain.firebaseio.com",
  storeageBucket: "build-the-mountain.appspot.com",
  messagingSenderId: "410603588212"
}

const base = Rebase.createClass(config);

export default base;


// WEBPACK FOOTER //
// ./src/base.js